import { motion } from 'framer-motion';
import { fadeInUp } from '../../../styles/animations';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import {
    Card,
    CardContent,
    Typography,
    Button,
    Stack,
} from '@mui/material';
import { CheckCircle2, XCircle } from 'lucide-react';
import { Box } from '@mui/material';

export default function AnswerCard({
    lastAnswer,
    onNext,
    onPrev,
    currentIndex,
    totalQuestions,
    nextLabel,
}) {
    if (!lastAnswer) return null;

    return (
        <motion.div {...fadeInUp}>
            <Card>
                <CardContent>
                    {/* Question */}
                    <Typography variant="h6" mb={2}>
                        {lastAnswer.questionText}
                    </Typography>

                    {/* User Answer */}
                    <Typography mt={1.5} color="text.secondary">
                        <strong>Your answer:</strong>{' '}
                        {lastAnswer.userAnswer}
                    </Typography>

                    {/* Feedback */}
                    <Box
                        mt={3}
                        p={2}
                        borderRadius={2}
                        sx={{
                            backgroundColor: lastAnswer.isCorrect
                            ? 'rgba(76, 175, 80, 0.15)'
                            : 'rgba(244, 67, 54, 0.15)',
                            borderLeft: '10px solid',
                            borderRight: '10px solid',
                            borderColor: lastAnswer.isCorrect
                            ? 'success.main'
                            : 'error.main',
                        }}
                    >

                    <Stack direction="row" spacing={1} alignItems="center">
                        {lastAnswer.isCorrect ? (
                            <CheckCircle2 size={20} />
                        ) : (
                            <XCircle size={20} />
                        )}

                        <Typography
                            fontWeight={600}
                            color={lastAnswer.isCorrect ? 'success.main' : 'error.main'}
                        >
                            {lastAnswer.isCorrect ? 'Correct' : 'Incorrect'}
                        </Typography>
                    </Stack>

                    {!lastAnswer.isCorrect && (
                        <Typography mt={1} color="text.primary">
                            <strong>Correct answer:</strong>{' '}
                            {lastAnswer.correctAnswer}
                        </Typography>
                    )}
                    </Box>

                    {/* Navigation */}
                    <Stack
                        direction='row'
                        justifyContent='space-between'
                        mt={3}
                    >
                        <Button
                            onClick={onPrev}
                            disabled={currentIndex === 0}
                            startIcon={<ChevronLeft />}
                            variant='outlined'
                        >
                            Previous
                        </Button>
                        <Button
                            onClick={onNext}
                            // nextLabel doing double duty here. A bit janky for now. this disabled condition is for the Review your answers section on the quiz component. Ex. This way nextLabel acts as a single flag that controls both the label and the disabled behaviour, which is consistent and requires no new props.TODO consider improving
                            disabled={nextLabel !== undefined && currentIndex + 1 >= totalQuestions}
                            endIcon={<ChevronRight />}
                            variant='contained'
                        >
                          {/* nextLabel Allows review your results section to modify this label when needed */}
                          {nextLabel ?? (currentIndex + 1 < totalQuestions ? 'Next' : 'Finish')}
                        </Button>
                    </Stack>
                </CardContent>
            </Card>
        </motion.div>
    );
}
